module.exports = __webpack_public_path__ + "img/tms.33cca1dd.jpg";